export default {"src":"/_next/static/media/CHKP.1325893a.svg","height":18,"width":18};